import script from "./FeedPostComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedPostComment.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__